const VideoPlayer = (window as any).VideoPlayer as any;
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import { PlayerEventCallbackFn } from './video';
import { EventNames } from '@swisslife/shared-ui/src/utils/custom-event/js/custom-event';

export interface IInitMovingImageReturn {
	remove: () => void;
	addEventCallback: (callbackFn: PlayerEventCallbackFn) => void;
}

export const initMovingImage = async (videoContext: GondelJqueryComponent) => {
	const playerCallbacks: PlayerEventCallbackFn[] = [];
	const { playerContainerId, autoplay } = videoContext.$ctx.data();
	const videoId = videoContext.$ctx.find(`#${playerContainerId}`).attr('video-id') || 'no video-id';
	let player;
	let videoTitle = 'no video-title';
	let progress: 0 | 25 | 50 | 75 | 100 = 0;
	let progressInterval;

	const initPlayerAutoplayOff = {
		success: (playerApi) => {
			// store player instance for later usage
			player = playerApi;

			videoTitle = player.getApi('metaData').getVideoTitle();
			bindCustomEvents();
			player.stop();
		},
	};

	const initPlayerAutoplayOn = {
		success: (playerApi) => {
			// store player instance for later usage
			player = playerApi;

			videoTitle = player.getApi('metaData').getVideoTitle();
			bindCustomEvents();
			player.toggleMute();
			player.play();
		},
	};

	const bindCustomEvents = () => {
		player.registerEventListener('play', () => {
			triggerCustomEventCallback(EventNames.VideoPlay);
			progressInterval = setInterval(trackProgress, 1000);
		});
		player.registerEventListener('pause', () => {
			triggerCustomEventCallback(EventNames.VideoStop);
			clearInterval(progressInterval);
		});
		player.registerEventListener('ended', () => {
			triggerCustomEventCallback(EventNames.VideoComplete);
			clearInterval(progressInterval);
			progress = 0;
		});
		player.registerEventListener('timeupdate', () => trackProgress());
	};

	const triggerCustomEventCallback = (eventName: EventNames, includeProgress: boolean = false) => {
		playerCallbacks.forEach((playerCallback) => {
			playerCallback('movingImage', eventName, videoId, videoTitle, includeProgress ? progress : undefined);
		});
	};

	const trackProgress = () => {
		// return if we have already fired all three progress events
		if (progress === 75) {
			return;
		}

		const currentTime = player.getCurrentTime();
		const currentPercentage = Math.floor((currentTime / player.getDuration()) * 100);

		// fire progress event if we just crossed a threshold of 25/50/75 percent
		if (currentPercentage >= 25 && progress === 0) {
			progress = 25;
			triggerCustomEventCallback(EventNames.VideoProgress, true);
		}
		if (currentPercentage >= 50 && progress === 25) {
			progress = 50;
			triggerCustomEventCallback(EventNames.VideoProgress, true);
		}
		if (currentPercentage >= 75 && progress === 50) {
			progress = 75;
			triggerCustomEventCallback(EventNames.VideoProgress, true);
		}
	};

	if (typeof VideoPlayer !== 'undefined') {
		const initPlayer = autoplay ? initPlayerAutoplayOn : initPlayerAutoplayOff;
		VideoPlayer.Collection.addPlayerById(playerContainerId, initPlayer);
	}

	return {
		remove: () => {
			VideoPlayer.Collection.removePlayerById(playerContainerId);
		},
		addEventCallback: (callbackFn) => {
			playerCallbacks.push(callbackFn);
		},
	};
};
